import { BaseEntity } from '../base-entity';
import { Bookmark } from './bookmark';
import { PbiReport } from './pbi-report';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
import { AuthzContext, AuthzContextsActionMap, CrudAction } from '@mri-platform/resource-authz';
/// </code-import>

export interface DraftBookmark {
  id: string;
  createdDate: Date;
  draftId: string;
  isCopy: boolean;
  isDefault: boolean;
  isDeleted: boolean;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  name: string;
  parentBookmarkId?: string;
  parentLastUpdatedDate: Date;
  periodEnd: Date;
  periodStart: Date;
  state: string;
  tenantKey: string;
  draft: PbiReport;
  parentBookmark: Bookmark;
}

/// <module-code> Place module level code between <module-code> tags
const typeFuncs = BaseEntity.makeStaticTypeFunctions<DraftBookmark>(EntityName.DraftBookmark);
/// </module-code>

export class DraftBookmark extends BaseEntity {
  /// <code> Place custom code between <code> tags
  get isOrphan(): boolean {
    return this.isCopy && this.parentBookmarkId == null;
  }

  static readonly propName = typeFuncs.propName;
  static readonly propNames = typeFuncs.propNames;
  static readonly qualifiedPropName = typeFuncs.qualifiedPropName;
  static readonly qualifiedPropNames = typeFuncs.qualifiedPropNames;

  static readonly authorization: AuthzContextsActionMap = {
    ...AuthzContextsActionMap.crudFor(EntityName.DraftBookmark),
    [CrudAction.Update]: AuthzContext.updateFor(
      ...DraftBookmark.qualifiedPropNames('state', 'name', 'isDefault', 'isDeleted')
    )
  };
  /// </code>
  // Generated code. Do not place code below this line.
}
